import * as React from 'react';
import { IBetDetailHeaderProps, BetDetailHeader } from './header';
import { IOddListRowProps, OddListRow } from './oddListRow';
import { TablePanel } from '../../componentsDesktop';
import { OddListHeaderForTipos } from './oddListHeader';
import { ITicketRowProps, TicketRow } from './ticketRow';
import { TicketHeader } from './ticketHeader';
import { translation } from 'easit--localization';
import { ActionsForTipos, IActionsProps } from './actions';
import * as classnames from 'classnames';
import { Legend } from './legend';

export interface IBetDetailProps {
    title: string;
    header: IBetDetailHeaderProps;
    betOddsList: IOddListRowProps[];
    ticketList: ITicketRowProps[];
    actions?: IActionsProps;
    publicTicketLink?: string;
    showCancelButton: boolean;
    onCancel?: () => void;
    isCancelLoading?: boolean;
    cancelMessage?: string;
}

export const BetDetail: React.FC<IBetDetailProps> = (props) => {
   

    return <div className={"betdetail d-flex flex-column p-2"}>
        <div className={"d-flex justify-content-between"}>
            <h1 className="px-2">{props.title}</h1>
            {props.actions && <ActionsForTipos {...props.actions} />}
        </div>
        <div className={"d-flex flex-column flex-xxl-row"}>
            <div className="betdetail-header pr-xxl-2">
                <BetDetailHeader {...props.header} />
            </div>
            <div className={"betdetail-odds"}>
                <TablePanel className={classnames("betdetail-odds-table event-table mt-3 mb-0 mt-xxl-0", { "with-groupname": !!props.ticketList.length })} header={<OddListHeaderForTipos />} strapped>
                    {props.betOddsList && props.betOddsList.map((bet, index) => <React.Fragment key={`key_${index}`}><OddListRow {...bet} /></React.Fragment>)}
                </TablePanel>
            </div>
        </div>
        {!!props.ticketList.length &&
            <div className={"betdetail-ticket pr-xxl-2"}>
                <TablePanel className="betdetail-ticket-table mt-3" header={<TicketHeader />} strapped>
                    {props.ticketList && props.ticketList.map(item => <TicketRow {...item} />)}
                </TablePanel>
            </div>
        }

        <div className="d-flex align-items-center mt-2">
            {
                /*props.showCancelButton &&
                <div>
                    <ButtonPrimary className="mr-2" onClick={props.onCancel}>STORNO</ButtonPrimary>
                </div>*/
            }

            {
                //renderCancelMessage(props.isCancelLoading, props.cancelMessage)
            }
        </div>

        <Legend />

        {props.publicTicketLink &&
            <div>
                {translation().ticket_public_link}
                <a className="ml-2 public-link" href={props.publicTicketLink} target="_blank">{props.publicTicketLink}</a>
            </div>
        }
    </div>
}

